import React from "react";
import Button from "../../Button/Button";
import classes from "./LoginAlert.module.css";

interface Props {
  modalClosed: () => void;
  infoText: string | undefined | null | JSX.Element[];
}

const LoginAlert: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, infoText } = { ...props };
  const btnStyle = {
    margin: "10px",
    minWidth: "50px",
    width: "100px",
  };

  return (
    <div className={classes.popupBody}>
      {/* <div className={classes.closeBtn} onClick={modalClosed}>
        X
      </div> */}
      <p>
        <strong>{infoText}</strong>
      </p>
      <Button
        label="Ok"
        clicked={modalClosed}
        style={btnStyle}
        displayImg={false}
        image=""
        disabled={false}
      />
    </div>
  );
};
export default LoginAlert;
